<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import UiToast from '../../ui/UiToast.vue'
import { useEuriborStore } from '../market/euriborStore'
import { useIrsStore } from '../market/irsStore'

const route = useRoute()
const euriborStore = useEuriborStore()
const irsStore = useIrsStore()

const shouldWarn = computed(
    () =>
        !!route.meta.requiresMarket &&
        (irsStore.irsInitialized === false || euriborStore.euriborInitialized === false)
)

const open = ref(false)

watch(shouldWarn, (warn) => (open.value = warn), { immediate: true })
</script>

<template>
    <UiToast :open="open" severity="warn" position="top-right" :life="6000" @close="open = false">
        <span class="text-lg font-bold">Servicio no disponible</span>
        <span>Fallo al cargar los datos Euribor/IRS del BdE.</span>
        <span>Los valores se han establecido a cero.</span>
        <span>Por favor, inténtalo de nuevo más tarde.</span>
    </UiToast>
</template>
